<template>
    <div class="trz_leave_settings pt-4">
        <!--<employee-public-info ></employee-public-info>-->

        <b-overlay :show="showoverlay" rounded="sm" class="col-md-12">
            <div v-if="showoverlay" style="min-height: 400px;"></div> <!-- Mustafijur: 17-05-2026 -->
            <template v-if="leave_available.length > 0">
                <template v-if="startDate.length > 0">
                    <div class="row ">
                        <div class="col-sm-8">
                            <div class="card">
                                <div class="card-header"> <!-- Mustafijur: 13-05-2026 -->
                                    Leave Year/Contract Date Range From {{ startDate }} To {{ endDate }}
                                </div>

                                <div class="card-body ">
                                    <div v-if="toggle_reset" class="row">
                                        <div class="col-sm-6">
                                            <b-form-group id="day_one-group" label="From [YYYY-MM-DD] "
                                                label-for="day_one_text">
                                                <b-input-group class="mb-3">
                                                    <b-form-input v-model="day_one" type="text" disabled></b-form-input>
                                                </b-input-group>
                                            </b-form-group>
                                        </div>

                                        <div class="col-sm-6">
                                            <b-form-group id="day_two-group" label="To [YYYY-MM-DD] "
                                                label-for="day_two_text">
                                                <b-input-group class="mb-3">
                                                    <b-form-input v-model="day_two" type="text" disabled></b-form-input>
                                                </b-input-group>
                                            </b-form-group>
                                        </div>
                                    </div>

                                    <div class="row" :class="editable">
                                        <b-form-group class="ml-3" label="Leave Day" label-for="leave_day"
                                            v-slot="{ ariaDescribedby }">
                                            <b-form-radio-group :disabled="toggle_reset" @change="reloadType"
                                                id="leave_day-group" v-model="fdata.leave_day" :options="leaveDay"
                                                :aria-describedby="ariaDescribedby"
                                                name="leave_day"></b-form-radio-group>
                                        </b-form-group>

                                        <!-- <template v-if="leavetypes_options.length > 0"> -->
                                        <template>
                                            <b-form-group id="leave_type_id-group" label="Leave Type"
                                                class="required-field" label-for="leave_type_id">
                                                <b-form-select :disabled="toggle_reset" @change="reloadCalendar"
                                                    id="leave_type_id" name="leave_type_id"
                                                    v-model="fdata.leave_type_id" v-validate="{ required: true }"
                                                    :state="validateState('leave_type_id')"
                                                    aria-describedby="leave_type_id-feedback" data-vv-as="Leave Type">
                                                    <b-form-select-option v-for="leave_type in leavetypes_options"
                                                        :key="leave_type.leave_type_id"
                                                        :value="leave_type.leave_type_id">{{ leave_type.leave_type_title
                                                        }}</b-form-select-option>
                                                </b-form-select>
                                                <b-form-invalid-feedback id="leave_type-feedback">{{
                                                    veeErrors.first('leave_type_id') }}</b-form-invalid-feedback>
                                            </b-form-group>
                                        </template>
                                    </div>

                                    <template v-if="fdata.leave_type_id > 0">

                                        <template v-if="leavetypes_options.length > 0">

                                            <div class="row" :class="editable">

                                                <template v-if="auto == 1">

                                                    <div class="col-sm-6">
                                                        <b-form-group id="day_one-group" label="From [YYYY-MM-DD] *"
                                                            label-for="day_one_text">
                                                            <b-input-group class="mb-3">
                                                                <b-form-input id="day_one_text" name="day_one_text"
                                                                    v-model="day_one" v-validate="{ required: true }"
                                                                    type="text" placeholder="YYYY-MM-DD"
                                                                    autocomplete="off" @change="updateToDate"
                                                                    :state="validateState('day_one_text')"
                                                                    aria-describedby="day_one_text-feedback"
                                                                    data-vv-as="From Date"></b-form-input>
                                                                <b-input-group-append>
                                                                    <b-form-datepicker id="day_one"
                                                                        @context="updateToDate()" button-only right
                                                                        locale="en-US" v-model="day_one"
                                                                        :start-weekday="fetchStartWeekday"></b-form-datepicker>
                                                                </b-input-group-append>
                                                                <b-form-invalid-feedback id="day_one_text-feedback">{{
                                                                    veeErrors.first('day_one_text')
                                                                }}</b-form-invalid-feedback>
                                                            </b-input-group>
                                                        </b-form-group>
                                                    </div>

                                                    <div class="col-sm-6" :class="{ 'd-none': fdata.leave_day > 0 }">
                                                        <b-form-group id="day_two-group" label="To [YYYY-MM-DD] *"
                                                            label-for="day_two_text">
                                                            <b-input-group class="mb-3">
                                                                <b-form-input id="day_two_text" name="day_two_text"
                                                                    v-model="day_two" v-validate="{ required: true }"
                                                                    type="text" placeholder="YYYY-MM-DD"
                                                                    autocomplete="off" @change="adjustValidDate"
                                                                    :state="validateState('day_two_text')"
                                                                    aria-describedby="day_two_text-feedback"
                                                                    data-vv-as="To Date"></b-form-input>

                                                                <b-input-group-append>
                                                                    <b-form-datepicker id="day_two" button-only right
                                                                        locale="en-US" :min="min" v-model="day_two"
                                                                        :start-weekday="fetchStartWeekday"></b-form-datepicker>
                                                                </b-input-group-append>

                                                                <b-form-invalid-feedback id="day_two_text-feedback">{{
                                                                    veeErrors.first('day_two_text')
                                                                }}</b-form-invalid-feedback>
                                                            </b-input-group>
                                                        </b-form-group>
                                                    </div>
                                                </template>
                                                <template v-else>

                                                    <div class="col-sm-6">
                                                        <b-form-group id="day_one-group" label="From [YYYY-MM-DD] *"
                                                            label-for="day_one_text">
                                                            <b-input-group class="mb-3">
                                                                <b-form-input id="day_one_text" name="day_one_text"
                                                                    v-model="day_one" v-validate="{ required: true }"
                                                                    type="text" placeholder="YYYY-MM-DD"
                                                                    autocomplete="off" @change="updateToDate"
                                                                    :state="validateState('day_one_text')"
                                                                    aria-describedby="day_one_text-feedback"
                                                                    data-vv-as="From Date"></b-form-input>
                                                                <b-input-group-append>
                                                                    <b-form-datepicker id="day_one"
                                                                        @context="updateToDate()" button-only right
                                                                        locale="en-US" v-model="day_one"
                                                                        :date-disabled-fn="dateDisabled"
                                                                        :start-weekday="fetchStartWeekday"></b-form-datepicker>
                                                                </b-input-group-append>
                                                                <b-form-invalid-feedback id="day_one_text-feedback">{{
                                                                    veeErrors.first('day_one_text')
                                                                }}</b-form-invalid-feedback>
                                                            </b-input-group>
                                                        </b-form-group>
                                                    </div>

                                                    <div class="col-sm-6" :class="{ 'd-none': fdata.leave_day > 0 }">
                                                        <b-form-group id="day_two-group" label="To [YYYY-MM-DD] *"
                                                            label-for="day_two_text">
                                                            <b-input-group class="mb-3">
                                                                <b-form-input id="day_two_text" name="day_two_text"
                                                                    v-model="day_two" v-validate="{ required: true }"
                                                                    type="text" placeholder="YYYY-MM-DD"
                                                                    autocomplete="off" @change="adjustValidDate"
                                                                    :state="validateState('day_two_text')"
                                                                    aria-describedby="day_two_text-feedback"
                                                                    data-vv-as="To Date"></b-form-input>

                                                                <b-input-group-append>
                                                                    <b-form-datepicker id="day_two"
                                                                        @context="adjustValidDate()" button-only right
                                                                        locale="en-US" :min="min" v-model="day_two"
                                                                        :date-disabled-fn="dateDisabled"
                                                                        :start-weekday="fetchStartWeekday"></b-form-datepicker>
                                                                </b-input-group-append>

                                                                <b-form-invalid-feedback id="day_two_text-feedback">{{
                                                                    veeErrors.first('day_two_text')
                                                                }}</b-form-invalid-feedback>
                                                            </b-input-group>
                                                        </b-form-group>
                                                    </div>
                                                </template>



                                            </div>


                                            <div class='mt-2'>
                                                <div class="row">
                                                    <div class="col-sm-12">
                                                        <!-- Abdullah: 13-05-2026 col-sm-6 TO col-sm-12 -->


                                                        <!--<template v-if="this.toggle_reset">-->
                                                        <b-form-group id="flg_status-group" label="Leave Status"
                                                            class="required-field" label-for="flg_status">
                                                            <b-form-select id="flg_status" name="flg_status"
                                                                v-model="fdata.flg_status">
                                                                <b-form-select-option v-for="leavetatus in leavestatus"
                                                                    :key="leavetatus.value" :value="leavetatus.value">{{
                                                                    leavetatus.text }}</b-form-select-option>
                                                            </b-form-select>
                                                        </b-form-group>
                                                        <!--</template>-->
                                                    </div>
                                                    <div class="col-sm-12">
                                                        <!-- Abdullah: 13-05-2026 col-sm-6 TO col-sm-12 -->
                                                        <b-form-group id="attachment-group" label="Attachment"
                                                            label-for="attachment">
                                                            <b-form-file @change="checkFileType($event, 'attachment', ['.jpg', '.png', '.gif', '.pdf'])"
                                                                id="attachment" v-model="attachment"
                                                                accept=".jpg, .png, .gif, .pdf"
                                                                placeholder="Choose a file or drop it here..."
                                                                drop-placeholder="Drop file here..."
                                                                aria-describedby="form_etin_scan-feedback"
                                                                data-vv-as="Attachment"></b-form-file>
                                                        </b-form-group>
                                                    </div>


                                                </div>
                                                <div class="row"> <!-- Abdullah: 13-05-2026 col-sm-6 TO col-sm-12 -->
                                                    <div class="col-sm-12">
                                                        <b-form-group id="comment-group" label="Reason/Comment"
                                                            class="required-field" label-for="comment">
                                                            <b-form-textarea id="comment" name="comment" rows="5"
                                                                max-rows="6" no-resize v-model="fdata.comment"
                                                                v-validate="{ required: true, min: 3 }"
                                                                :state="validateState('comment')"
                                                                aria-describedby="comment-feedback"
                                                                data-vv-as="Reason/Comment"></b-form-textarea>
                                                            <b-form-invalid-feedback id="comment-feedback">{{
                                                                veeErrors.first('comment')
                                                            }}</b-form-invalid-feedback>
                                                        </b-form-group>


                                                    </div>
                                                </div>

                                                <!-- alpha fix- acommented this  -->
                                                <!-- <div class="clearfix text-center">

                                                    <template v-if="show_reset == 1">
                                                        <div class="float-left mr-2">
                                                            <b-button v-if="toggle_reset" @click="changeDate" type="button" >Change Date / Type</b-button>

                                                            <b-button v-else class="ml-2 custom-wizard-btn" @click="resetChangeDate" type="button" >Reset</b-button>
                                                        </div>

                                                        <b-button @click="deleteLeave" type="button" class="mx-2">Delete</b-button>

                                                    </template>




                                                    <div class=""><b-button :disabled="disable_flg" @click="saveLeave()">Save</b-button></div>


                                                    <div class="float-right font-italic mt-3" :class="my_class">Affected Day(s) :
                                                        <span v-if="toggle_reset">{{days}}</span>
                                                        <span v-else>{{dateDiff}}</span>
                                                    </div>

                                                    <div v-if="excess" class="float-right font-italic mx-2 mt-3" :class="my_class ">Exceeded Leave!</div>
                                                </div> -->


                                                <!-- alpha fix- added this  -->
                                                <div class="mt-3">
                                                    <div
                                                        class="d-flex align-items-center justify-content-center flex-nowrap leave-action-btn-custom-btn">
                                                        <template v-if="show_reset == 1">
                                                            <b-button v-if="toggle_reset" @click="changeDate"
                                                                type="button" class="mr-2">Change Date / Type</b-button>
                                                            <b-button v-else class="custom-wizard-btn mr-2"
                                                                @click="resetChangeDate" type="button">Reset</b-button>
                                                        </template>

                                                        <b-button :disabled="disable_flg" @click="saveLeave()"
                                                            class="mr-2">Save</b-button>

                                                        <template v-if="show_reset == 1">
                                                            <b-button @click="deleteLeave"
                                                                type="button">Delete</b-button>
                                                        </template>
                                                    </div>
                                                    <div class="text-right font-italic mt-2" :class="my_class">
                                                        Affected Day(s) :
                                                        <span v-if="toggle_reset">{{ days }}</span>
                                                        <span v-else>{{ dateDiff }}</span>
                                                        <span v-if="excess" class="mx-2">Exceeded Leave!</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                        <template v-else>No allowed leave type available.</template>
                                    </template>
                                </div>
                            </div>
                        </div>


                        <!----->


                        <div class="col-sm-4">
                            <div class="card ">
                                <!-- alpha fix- make color to background color and added text-center  -->
                                <div class="card-header table-head"
                                    style="background-color: #004242; text-align: center;">
                                    <!-- Abdullah: 13-05-2026 style="color: #004242;" -->
                                    List of Leave Applications
                                </div>
                                <div class="card-body " style="height:335px; overflow-y:scroll;">
                                    <ul class="list-group list-group-flush">
                                        <li class="list-group-item px-0" v-for="leave in leaves"
                                            :key="leave.leave_date">
                                            <div class="cursor-pointer"
                                                :title="leave.leave_title + ' - ' + leave.comment" v-b-tooltip
                                                placement="right" @click="updateLeave(leave.id)">
                                                <a class="edit-icon mr-2 float-none d-inline-block" href="#"
                                                    @click="updateLeave(leave.id)"><i class="fa fa-pencil-alt"></i></a>
                                                {{ formatdate(leave.leave_date) }} - {{ leave.status }}
                                            </div>
                                        </li>
                                    </ul>
                                    <div v-if="leaves.length == 0">
                                        {{ blankmsg }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <b-modal id="bv-modal-leave" hide-footer v-bind:title="leave_details.leave_date" v-if="ce">
                            <b-form @submit.stop.prevent="onSubmitLeaveUpdate">
                                <input type="hidden" v-model="leave_details.id" name="id">

                                <b-form-group id="status-group" label="Status" label-for="status">
                                    <b-form-select id="status" name="status" v-model="leave_details.flg_status"
                                        v-validate="{ required: true }" :options="leavestatus"></b-form-select>

                                </b-form-group>
                                <!-- alpha fix- maked the btn cemnter  -->
                                <div class="text-center">
                                    <b-button type="submit" variant="primary">Submit</b-button>
                                </div>

                            </b-form>
                        </b-modal>
                    </div>
                    <div class="row mt-4">

                        <div class="col-sm-12">
                            <!-- alpha fix removed class border-bottom and added text-center  -->
                            <h5 class="mb-3 text-center pb-3">Annual Leave Entitlement</h5>
                            <table class="table">
                                <thead>
                                    <tr class="table-head">
                                        <th>Type</th>
                                        <th>Leaves Allowed</th>

                                        <th>Carried</th>
                                        <th>Applied</th>
                                        <th>Enjoyed</th>
                                        <th>Encashed</th>

                                        <th>Remaining</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="table-row hover-bg" v-for="leave_type in leave_available"
                                        :key="leave_type.id">
                                        <td>{{ leave_type.leave_title }}</td>

                                        <td>{{ leave_type.allowed }} Days</td>

                                        <td>{{ leave_type.carried }} Days</td>
                                        <td>{{ leave_type.applied }} Days</td>
                                        <td>{{ leave_type.enjoyed }} Days</td>
                                        <td>{{ leave_type.encashed }} Days</td>
                                        <td>{{ leave_type.remaining }} Days</td>
                                    </tr>
                                </tbody>
                            </table>

                        </div>

                    </div>
                </template>
                <template v-else>
                    <div class=" vertical-center">
                        <div class="container font-weight-bold text-danger">
                            No active contract found.
                        </div>
                    </div>
                </template>
            </template>
            <template v-else-if="has_contract == false">
                <div class=" vertical-center">
                    <div class="container font-weight-bold text-danger">
                        No active contract found.
                    </div>
                </div>
            </template>
            <template v-else>
                <div class=" vertical-center" v-if="show_warning">
                    <div class="container font-weight-bold text-danger">
                        No leave policy defined or assigned leave policy doesn't have any day amount defined or leave
                        year not unlocked!
                    </div>
                </div>
            </template>
        </b-overlay>

    </div>
</template>
<script>

import moment from 'moment'

export default {

    mounted() {

    },
    props: ['editflg', 'leave_type_id', 'flg_status', 'from', 'to', 'attendances_date', 'leave_day'],
    components: {

    },
    data() {

        const now = new Date()
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
        // 15th two months prior
        const minDate = new Date(today)
        minDate.setMonth(minDate.getMonth())
        minDate.setDate(minDate.getDate() + 1)

        const startdate = minDate


        var startDate = '';
        var endDate = '';


        return {
            excess: false,
            startDate: startDate,
            endDate: endDate,


            min: minDate,
            //max: maxDate,
            showoverlay: false,


            // day_one: moment(String(startdate)).format('YYYY-MM-DD') ,
            // day_two: moment(String(startdate)).format('YYYY-MM-DD') ,

            day_one: '',
            day_two: '',


            fdata: { leave_day: 0, day_one: this.day_one, day_two: this.day_two, days: null, leave_type_id: null, flg_status: 0, comment: null },
            leave_details: {},

            attachment: null,

            company_id: 0,

            ce: true,

            my_class: '',

            blankmsg: 'Fetching data..',

            holidays: [],
            leaves: [],
            holidays_date_arr: [],
            leave_limit: [],
            leave_available: [],
            disable_flg: false,

            week_holidays: [6],
            all_week_holidays: [6],
            week_start_day: 7,
            count_options: [
                { value: 1, text: '1' },
                { value: 2, text: '2' },
                { value: 3, text: '3' },
                { value: 4, text: '4' },
                { value: 5, text: '5' },
                { value: 6, text: '6' },
                { value: 7, text: '7' },
                { value: 8, text: '8' },
                { value: 9, text: '9' },
            ],


            options: [
                { text: 'Friday', value: '5' },
                { text: 'Saturday', value: '6' },
                { text: 'Sunday', value: '0' },
                { text: 'Monday', value: '1' },
                { text: 'Tuesday', value: '2' },
                { text: 'Wednesday', value: '3' },
                { text: 'Thursday', value: '4' }
            ],
            //1 for casual leave, 2 for sick leave, 3 for annual leave, 4 for unpaid leave, 5 for compaensatory leave
            leavetypes: [],
            leavetypes_options: [],
            exceeded_leave_types: [],

            leavestatus: [
                { text: 'Applied', value: '0' },
                { text: 'Approved', value: '1' },
                { text: 'Declined', value: '2' },
            ],

            fake: 0,
            days: 0,
            ids: 0,
            show_reset: 0,
            toggle_reset: false,
            editable: '',

            show_warning: false,
            show_form: false,

            off_day_on_leave: 0,
            skip_days: {},

            has_contract: true,

            leaveDay: [
                { text: 'Full Day', value: '0' },
                { text: 'First Half', value: '1' },
                { text: 'Second Half', value: '2' },
            ],

            can_exceed: [],

            auto: 0,
            systemEndDate: endDate,

        }
    },
    methods: {
        reloadCalendar: function () {

            if (this.attendances_date != null) {
                this.day_one = this.attendances_date;
                this.day_two = this.attendances_date;
                this.fdata.day_one = this.attendances_date;
                this.fdata.day_two = this.attendances_date;
            } else {
                this.day_one = '';
                this.day_two = '';
                this.fdata.day_one = '';
                this.fdata.day_two = '';
            }
            const item = this.leavetypes_options.find(x => x.leave_type_id === this.fdata.leave_type_id);

            if (item && item.event > 0) this.auto = 1;
            else this.auto = 0;



            const leaveIdToFind = this.fdata.leave_type_id;
            const leaveItem = this.leavetypes.find(item => item.leave_type_id === leaveIdToFind);

            if (leaveItem && leaveItem.ignore_off_day_on_leave > 0) {
                this.off_day_on_leave = leaveItem.off_day_on_leave;
            }
        },
        // reloadCalendar: function()
        // {

        //     // Mustafijur: 13-05-2026: Starts
        //     // this.day_one = '';
        //     // this.day_two = '';
        //     // this.fdata.day_one = '';
        //     // this.fdata.day_two = '';

        //     if(this.attendances_date != null) {
        //         this.day_one = this.attendances_date;
        //         this.day_two = this.attendances_date;
        //         this.fdata.day_one = this.attendances_date;
        //         this.fdata.day_two = this.attendances_date;
        //     }else{
        //         this.day_one = '';
        //         this.day_two = '';
        //         this.fdata.day_one = '';
        //         this.fdata.day_two = '';
        //     }
        //     // Mustafijur: 13-05-2026: Ends
        //     const item = this.leavetypes_options.find(x => x.leave_type_id === this.fdata.leave_type_id);

        //     if(item.event > 0)this.auto = 1;
        //     else this.auto = 0;



        //     const leaveIdToFind = this.fdata.leave_type_id;
        //     const leaveItem = this.leavetypes.find(item => item.leave_type_id === leaveIdToFind);

        //     if(leaveItem.ignore_off_day_on_leave > 0)
        //     {
        //         this.off_day_on_leave = leaveItem.off_day_on_leave;
        //     }
        // },
        fetchLeavesByRangeTypeStatus: function () {
            this.day_one = this.from;
            this.day_two = this.to;
            this.fdata.leave_type_id = this.leave_type_id;
            this.reloadCalendar();

            // to set the to date without depending on from date
            setTimeout(function () { this.fake = 0; }.bind(this), 1000);



            let formData = new FormData();
            //formData.append('employee_id', employee_id);
            formData.append('leave_type_id', this.leave_type_id);
            formData.append('flg_status', this.flg_status);
            formData.append('from', this.from);
            formData.append('to', this.to);

            axios.post(this.$api_url + '/employee/leaves/range', formData)
                .then(function (response) {


                    this.fdata.comment = response.data.comment;
                    this.fdata.leave_day = response.data.leave_day;
                    this.fdata.flg_status = response.data.flg_status;
                    this.days = response.data.days;
                    this.ids = response.data.ids;
                    this.show_reset = 1;
                    //this.editable = 'd-none';


                    //this.$validator.reset();
                }.bind(this))
                .catch(function (error) {
                    currentObj.serverError(error);
                });
        },
        resetChangeDate: function () {
            this.showoverlay = true;
            this.toggle_reset = !this.toggle_reset;

            this.getEmployeeLeaveSettings();
            this.getLeaveTypeByLeavePolicy();
            this.getHoliDays();
            this.getLeaves();

            if (this.editflg == 1) {
                this.fake = 1;
                this.fetchLeavesByRangeTypeStatus();
            }

            setTimeout(function () { this.showoverlay = false; }.bind(this), 1000);

        },
        changeDate: function () {
            this.showoverlay = true;
            this.editable = '';

            this.toggle_reset = !this.toggle_reset;
            this.fdata.flg_status = 0;
            //this.leave_available.forEach(element => {
            this.leave_available.forEach((element, index) => {


                if (element.leave_type_id == this.leave_type_id) {
                    this.leave_available[index].remaining_days = this.leave_available[index].remaining_days + this.days;
                    this.leave_limit[this.leave_type_id] = this.leave_limit[this.leave_type_id] + this.days;
                }


                this.day_one = this.from;
                this.fdata.leave_type_id = this.leave_type_id;
                // to set the to date without depending on from date
                setTimeout(function () { this.fake = 0; }.bind(this), 1000);
                this.day_two = this.to;

            });

            this.showoverlay = false;

        },

        dateDisabled(ymd, date) {
            const x = moment(String(date)).format('YYYY-MM-DD');
            const weekday = date.getDay();
            const day = date.getDate();
            return this.all_week_holidays.includes(weekday) || this.holidays_date_arr.includes(x);
        },
        // updateToDate:function()
        // {
        //     if(this.fake == 1)return;

        //     if(this.fdata.updateToDate == '')return;

        //     if(this.fdata.day_one == '')return;

        //     this.min = this.day_one;



        //     if(this.auto == 0)
        //     {
        //         this.endDate = this.systemEndDate;
        //     }
        //     else
        //     {

        //         const item = this.leavetypes_options.find(x => x.leave_type_id === this.fdata.leave_type_id);

        //         // console.log(item);

        //         const day_one = moment(String(this.day_one)).format('YYYY-MM-DD');
        //         const day_two = moment(day_one).add(parseInt (item.leave_days - 1), 'days');
        //         this.day_two = moment(String(day_two)).format('YYYY-MM-DD');

        //         return;


        //         // moment(selectedDate).add(180, 'days');
        //         // this.day_two = moment(this.day_one).add(180, 'days');
        //     }

        //     // move leave start date to preceeding off day
        //     if(this.off_day_on_leave == 2)
        //     {
        //         this.pushBackStartDate(this.day_one);
        //     }
        //     else
        //         this.day_two = this.day_one;

        // },

        updateToDate: function () {
            if (this.fake == 1) return;

            if (this.day_one == '') return;   // check the real v-model value, not fdata.day_one

            this.min = this.day_one;

            if (this.auto == 0) {
                this.endDate = this.systemEndDate;
            }
            else {
                const item = this.leavetypes_options.find(x => x.leave_type_id === this.fdata.leave_type_id);
                const day_one = moment(String(this.day_one)).format('YYYY-MM-DD');
                const day_two = moment(day_one).add(parseInt(item.leave_days - 1), 'days');
                this.day_two = moment(String(day_two)).format('YYYY-MM-DD');
                return;
            }

            if (this.off_day_on_leave == 2) {
                this.pushBackStartDate(this.day_one);
            }
            else
                this.day_two = this.day_one;
        },
        pushBackStartDate: function (x) {
            let m = moment(x);
            m.add(-1, 'days');
            if (this.skip_days.includes(m.format('YYYY-MM-DD'))) {
                // this.day_two = '';
                this.day_one = m.format('YYYY-MM-DD');
                this.day_two = this.day_one;
                this.pushBackStartDate(this.day_one);
            }
            else {
                this.day_two = this.day_one;
            }

        },
        adjustValidDate: function () {
            //this.checkOffDayOnLeave();
            if (moment(this.day_two).isBefore(moment(this.day_one).format('YYYY-MM-DD')))
                this.day_two = this.day_one;

            else if (moment(this.day_two).isAfter(moment(this.endDate).format('YYYY-MM-DD'))) {
                this.day_two = this.day_one;
            }
            else {
                // move leave end date to succeding off day
                if (this.off_day_on_leave == 2) {
                    let n = moment(this.day_two);
                    n.add(1, 'days');
                    if (this.skip_days.includes(n.format('YYYY-MM-DD'))) {
                        this.day_two = n.format('YYYY-MM-DD');
                        this.adjustValidDate();
                    }
                }
            }
        },
        checkOffDayOnLeave: function () {
            alert(this.off_day_on_leave);
        },

        formatdate: function (x) {
            return moment(x).format('YYYY-MM-DD');
        },
        checkGaterDate(x) {
            return moment(x).isAfter(moment(new Date()).format('YYYY-MM-DD'));
        },
        reloadType: function () {
            var x = this.fdata.leave_day;



            if (x > 0) {
                this.fdata = { leave_day: x, day_one: this.day_one, day_two: this.day_one, days: null, leave_type_id: null, flg_status: 0, comment: null };
                this.day_two = this.day_one;

            }
            this.getLeaves();
            this.getLeaveTypeByLeavePolicy(x);

        },
        getEmployeeLeaveSettings: function () {

            axios.get(this.$api_url + '/employee/leave/settings', {
                params: {
                    //id: x
                }
            }).then(function (response) {

                if (response.data.length != 0) {

                    this.company_id = response.data.company_id;
                    this.all_week_holidays = response.data.week_holidays;
                    this.week_holidays = response.data.week_holidays.split(',');
                    this.week_start_day = response.data.week_start_day;

                    this.off_day_on_leave = response.data.off_day_on_leave;
                    this.skip_days = response.data.skip_days.split(',');



                    //console.log(this.skip_days);
                    this.getLeaves();

                }

            }.bind(this));

        },
        getLeaveTypeByLeavePolicy: function (f = 0) {

            if (!this.checkNet()) return false;

            axios.get(this.$api_url + '/leave/type/by/leave/policy?f=' + f, {
                params: {

                }
            }).then(function (response) {

                this.leavetypes = response.data;
                this.leavetypes_options = response.data;

                if (this.leavetypes.length > 0)
                    this.show_warning = false;
                else
                    this.show_warning = true;

            }.bind(this));

        },
        updateLeave: function (x) {
            //leave_details
            axios.get(this.$api_url + '/employee/leave/details?id=' + x, {
                params: {
                    //id: x
                }
            }).then(function (response) {



                this.leave_details = response.data;

            }.bind(this));
            this.$bvModal.show('bv-modal-leave');
        },
        deleteLeave: function () {
            this.showoverlay = true;
            let formData = new FormData();
            //formData.append('employee_id' , employee_id);
            formData.append('leave_type_id', this.leave_type_id);
            formData.append('flg_status', this.flg_status);
            formData.append('from', this.from);
            formData.append('to', this.to);

            axios.post(this.$api_url + '/leave/delete/range', formData)
                .then(function (response) {
                    this.$bvToast.toast('Deleted!', {
                        title: `Success`,
                        variant: 'success',
                        solid: true
                    });

                    setTimeout(function () {
                        this.$emit('childToParent');
                        this.showoverlay = false;

                    }.bind(this)


                        , 1000);

                }.bind(this))
                .catch(function (error) {
                    this.showoverlay = false;
                    currentObj.showoverlay = false;
                    currentObj.serverError(error);
                });
        },
        onSubmitLeaveUpdate: function () {
            let currentObj = this;
            this.showoverlay = true;
            let formData = new FormData();
            for (let [key, value] of Object.entries(this.leave_details)) {
                var nm = `${key}`;
                var fval = `${value}`;
                formData.append(nm, fval);

            }
            axios.post(this.$api_url + '/employee/leave/details', formData,)
                .then(function (response) {
                    this.$bvToast.toast('Saved!', {
                        title: `Success`,
                        variant: 'success',
                        solid: true
                    });

                    this.getLeaves();
                    this.$bvModal.hide('bv-modal-leave');
                    this.$emit('childToParent');
                    this.showoverlay = false;

                }.bind(this))
                .catch(function (error) {
                    this.showoverlay = false;
                    currentObj.serverError(error);
                });
        },
        getHoliDays: function () {
            axios.get(this.$api_url + '/company/holidays', {
                params: {
                    //id: x
                }
            }).then(function (response) {

                if (response.data.length != 0) {

                    this.holidays = response.data.holidays;
                    this.holidays_date_arr = response.data.holidays_date_arr.split(',').map(function (item) { return item; });
                }

            }.bind(this));

        },
        getLeaves: function () {
            this.showoverlay = true;
            axios.get(this.$api_url + '/employee/leaves', {
                params: {
                    //id: x
                }
            }).then(function (response) {

                if (response.data.length != 0) {

                    this.leaves = response.data.leave_data;
                    this.leave_limit = response.data.limit;
                    this.leave_available = response.data.available;

                    this.can_exceed = response.data.can_exceed;


                    this.startDate = response.data.range.leave_limit_start_date;
                    this.endDate = response.data.range.leave_limit_end_date;

                    this.systemEndDate = this.endDate;


                    if (this.leaves.length == 0) {
                        this.blankmsg = 'Looks like no leave applied for the employee yet.';
                    }

                    if (this.leave_limit.length == 0) {
                        this.show_warning = true;
                    }
                    else {
                        this.show_warning = false;
                    }

                    this.has_contract = true;

                    this.exceeded_leave_types = response.data.exceeded_leave_types;

                    if (this.exceeded_leave_types.length > 0) {
                        this.leavetypes_options = this.leavetypes_options.filter(item => {
                            return !this.exceeded_leave_types.includes(item.leave_type_id);
                        });
                    }
                }
                else {
                    this.has_contract = false;
                }

                this.showoverlay = false;

            }.bind(this));

        },
        saveLeave: function () {
            this.$validator.validateAll().then(result => {
                if (!result) {
                    return;
                }

                let currentObj = this;
                let formData = new FormData();

                if (this.editflg == 1)
                    formData.append('ids', this.ids);

                if (!this.toggle_reset)
                    formData.append('removeids', this.ids);

                for (let [key, value] of Object.entries(this.fdata)) {
                    var nm = `${key}`;
                    var fval = `${value}`;
                    formData.append(nm, fval);

                }

                if (this.attachment) {
                    formData.append('attachment', this.attachment);
                }

                this.showoverlay = true;


                axios.post(this.$api_url + '/employee/leaves', formData,)
                    .then(function (response) {

                        if (response.data.status) {


                            this.$bvToast.toast('Saved!', {
                                title: `Success`,
                                variant: 'success',
                                solid: true
                            });


                            setTimeout(function () {
                                this.$emit('childToParent');
                                this.showoverlay = false;
                            }.bind(this), 1000);




                        }
                        else {
                            this.showoverlay = false;
                            this.$bvToast.toast(response.data.message, {
                                title: `Warning`,
                                variant: 'warning',
                                solid: true
                            });
                        }


                    }.bind(this))
                    .catch(function (error) {
                        this.showoverlay = false;
                        currentObj.serverError(error);
                    });

            });
        },
        validateState(ref) {
            if (
                this.veeFields[ref] &&
                (this.veeFields[ref].dirty || this.veeFields[ref].validated)
            ) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },
        fetchDateDisabled() {
            return this.week_holidays;
        },
        checkValidDate(date) {

            if (this.startDate <= date && date <= this.endDate) {
                return true;
            } else {
                return false;
            }
        },
    },
    created: function () {

        this.getEmployeeLeaveSettings();
        this.getLeaveTypeByLeavePolicy();
        this.getHoliDays();
        //this.getLeaves();

        if (this.editflg == 1) {
            this.fake = 1;
            this.fetchLeavesByRangeTypeStatus();

            this.toggle_reset = true;
        }
        else if (this.attendances_date != null) {

            this.fdata.day_one = this.attendances_date;
            this.day_one = this.attendances_date;
        }
        if (this.attendances_date) {
            this.day_one = this.attendances_date;
            this.day_two = this.attendances_date;
            this.fdata.day_one = this.attendances_date;
            this.fdata.day_two = this.attendances_date;
        }
    },
    computed:
    {

        dateDiff() {
            //fdata : {day_one:null , day_two:null, days:null , details:null},
            this.disable_flg = false;

            var day_one = moment(this.day_one);
            var day_two = moment(this.day_two);

            let days = 0;

            this.fdata.day_one = moment(String(this.day_one)).format('YYYY-MM-DD');
            this.fdata.day_two = moment(String(this.day_two)).format('YYYY-MM-DD');

            if (!this.checkValidDate(this.fdata.day_one)) {
                this.disable_flg = true;
                this.my_class = 'danger';

                if (this.day_one == '')
                    return 'Empty Date!';
                else
                    return 'Wrong Leave Year!';
            }



            if (this.day_one === this.day_two) {
                this.fdata.days = 1;
                //return 1;
                days = 1;
            }
            else {
                if (this.off_day_on_leave == 1) {
                    days = 1;
                    for (var m = moment(this.day_one); m.isBefore(this.day_two); m.add(1, 'days')) {
                        if (this.skip_days.includes(m.format('YYYY-MM-DD')))
                            continue;
                        ++days;
                    }
                }
                else {
                    days = day_two.diff(day_one, 'days') // 1
                    ++days;
                }
            }

            // if(this.auto > 0)
            //     --days;

            // alert(days);

            /*if(days > 0)
            {

                this.fdata.days = days;

                if(days > this.leave_limit[this.fdata.leave_type_id])
                {
                    this.disable_flg = true;

                    this.my_class = 'danger';

                    return 'Limit Exceed!';
                    // + this.leave_limit[this.fdata.leave_type_id] + ' >> ' + days; //fars
                }
                else
                {
                    this.disable_flg = false;
                    this.my_class = '';
                    return days;
                }

            }*/
            if (days > 0) {

                this.fdata.days = days;

                if (this.can_exceed.includes(this.fdata.leave_type_id)) {
                    //alert('can be exceed');
                    if (days > this.leave_limit[this.fdata.leave_type_id]) {
                        this.disable_flg = false;

                        this.my_class = 'danger';

                        this.excess = true;

                        return days;
                    }
                    else {
                        this.excess = false;
                        this.disable_flg = false;
                        this.my_class = '';
                        return days;
                    }
                }
                else {
                    if (days > this.leave_limit[this.fdata.leave_type_id]) {
                        this.disable_flg = true;

                        this.my_class = 'danger';

                        return 'Limit Exceed!';
                    }
                    else {
                        this.excess = false;
                        this.disable_flg = false;
                        this.my_class = '';
                        return days;
                    }
                }
            }
            else if (days < 0) {
                this.fdata.days = 0;
                this.disable_flg = true;
                return 'Invalid Date Range';
            }

        },
        fetchStartWeekday() {
            return this.week_start_day;
        },

    }
}
</script>
<style>
.trz_leave_settings .custom-select {
    width: auto !important;
}

.trz_list li {
    margin-top: 5px;
}

.danger {
    color: red;
}
</style>
